export default __webpack_public_path__ + "static/desktop-screen-f361618403f072ec29ae665ee9815c61.png";